import styled from "styled-components";
import { Button as BaseButton } from "antd";

export const Button = styled(BaseButton)`
  margin-left: 5px;
`;
